import axios from 'axios';

export default {
    methods: {
        async formularioIndex(d, ok, err) {
            try {
                let r = await axios.get('formulario?page=' + d.page, {params: d})
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async formularioStore(d, ok, err) {
            try {
                let r = await axios.post('formulario', d)
                ok(r.data)
            } catch (e) {
                err(e.response.data)
            }
        },
        async formularioUpdate(id, d, ok, err) {
            try {
                let r = await axios.put('formulario/' + id, d)
                ok(r.data)
            } catch (e) {
                err(e.response.data)
            }
        },
        async formularioShow(id, ok, err) {
            try {
                let r = await axios.get('formulario/' + id);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async formularioVincular(ok, err) {
            try {
                let r = await axios.post('formulario/vincular');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async formularioBuscar(d, ok, err) {
            try {
                let r = await axios.post('formulario/buscar', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/formulario/formulario.js